import request from '@/utils/request'

export const getWorkbenchApi = (data = '{}') => {
  return request({
    url: 'Home/Workbench',
    method: 'post',
    data,
  })
}
